import { TabContentTranslations } from ".";

export const TAB_CONTENT_EN_US: TabContentTranslations = {
	consolidated: "Consolidated",
	extract: "Extrato",
};
